import {useScreenDetector} from '../../../api/hook';
import {
    BackgroundColorInfo,
    BackgroundImageInfo,
    LatestUpdateItemDTO,
    LatestUpdateSection,
    Status,
} from '../../../api/models';
import {BackgroundBoxWrapper, BackgroundImageWrapper, Wrapper} from '../../../common/components';
import {Color} from '../../../common/theme';
import {Grid, Typography} from '@mui/material';
import {LatestUpdateComponent} from '../../DashboardScreen/components/latestupdate/LatestUpdateComponent';
import {TextComponent} from '../components/TextComponent';

export const WebsiteLatestUpdateSection = ({data}: {data: LatestUpdateSection; index: number}) => {
    const {isDesktop} = useScreenDetector();

    const getLatestUpdate = (updates: LatestUpdateItemDTO[]): LatestUpdateItemDTO | undefined => {
        const filteredUpdates = updates.filter((update) => update.status === Status.ACTIVE);
        if (filteredUpdates.length > 0) {
            return filteredUpdates[0];
        } else {
            return undefined;
        }
    };

    const latestUpdate = getLatestUpdate(data.latestUpdate);
    const layout = (
        <>
            <Grid container>
                <Grid item md={8} xs={12} sm={12}>
                    <Typography
                        component={'div'}
                        variant='h4'
                        style={{
                            color: Color.BLACK,
                            fontWeight: 700,
                            fontFamily: 'Poppins',
                        }}>
                        {data.title.text}
                    </Typography>
                </Grid>
            </Grid>
            {data.content ? (
                <Grid style={{marginTop: 12}} container>
                    <Grid item md={12} xs={12} sm={12}>
                        <TextComponent
                            content={data.content.text}
                            fontWeight={200}
                            color={Color.BLACK}
                            variant='body1'
                        />
                    </Grid>
                </Grid>
            ) : null}
            <br />
            <LatestUpdateComponent color={Color.BLACK} update={latestUpdate} />
        </>
    );

    switch (data.backgroundInfo?.type) {
        case 'BackgroundColor':
            return (
                <BackgroundBoxWrapper
                    isDesktop={isDesktop}
                    backgroundColor={(data.backgroundInfo as BackgroundColorInfo).backgroundColor}>
                    {layout}
                </BackgroundBoxWrapper>
            );
        case 'BackgroundImage':
            return (
                <BackgroundImageWrapper
                    backgroundImageUrl={(data.backgroundInfo as BackgroundImageInfo).backgroundImageUrl}>
                    <Wrapper isDesktop={isDesktop}>{layout}</Wrapper>
                </BackgroundImageWrapper>
            );
        default:
            return (
                <BackgroundBoxWrapper isDesktop={isDesktop} backgroundColor={Color.WHITE}>
                    {layout}
                </BackgroundBoxWrapper>
            );
    }
};

//
